/* Payment Item Types */
export const CERTIFICATE = 'certificate';
export const COURSE_ENROLMENT = 'course_enrolment';
export const SUBSCRIPTION_PLAN = 'subscription_plan';

export const PURCHASE_ITEM_TYPES = [
  CERTIFICATE,
  COURSE_ENROLMENT,
  SUBSCRIPTION_PLAN,
];

/* Currencies */
export const AUD = 'AUD';
export const MYR = 'MYR';
export const SGD = 'SGD';
export const USD = 'USD';

/* Country codes */
export const MALAYSIA = 'MY';

/* Payment Methods */
export const CREDIT_CARD = 'credit-card';
export const PAYPAL = 'paypal';
export const MOLPAY = 'molpay';
export const FPX = 'fpx';

/* Payment Gateways */
export const BRAINTREE = 'braintree';
export const STRIPE = 'stripe';

export const PAYMENT_METHODS = [CREDIT_CARD, PAYPAL, MOLPAY, FPX];
export const PAYMENT_GATEWAYS = [BRAINTREE, STRIPE];

/* Webhook Types */
export const STRIPE_FPX_WEBHOOK = 'stripe-webhook-fpx';
